export default "__VITE_ASSET__4836a378__"